(function ($) {
  "use strict";
  jQuery(document).ready(function () {
    document.onkeydown = function (e) {
      if (event.keyCode == 123) {
        return false;
      }
      if (e.ctrlKey && e.shiftKey && e.keyCode == 'I'.charCodeAt(0)) {
        return false;
      }
      if (e.ctrlKey && e.shiftKey && e.keyCode == 'C'.charCodeAt(0)) {
        return false;
      }
      if (e.ctrlKey && e.shiftKey && e.keyCode == 'J'.charCodeAt(0)) {
        return false;
      }
      if (e.ctrlKey && e.keyCode == 'U'.charCodeAt(0)) {
        return false;
      }
    }

    // menu toggler js
    $("button.navbar-toggler").on('click', function () {

      $(".main-menu-area").addClass("active");
      $(".mm-fullscreen-bg").addClass("active");
      $("body").addClass("hidden");
      window.scrollTo(0, 0);
      window.setTimeout(function () {
        $('.header-kaj').attr("class", "header-kaj");
      }, 100);

    });
    $(".close-box").on('click', function () {
      $(".main-menu-area").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
      $("body").removeClass("hidden");
    });

    // filter button js
    $("button.filter-button").on('click', function () {
      $(".filter-sidebar").addClass("active");
      $(".mm-fullscreen-bg").addClass("active");
    });
    $("button.close-filter-sidebar").on('click', function () {
      $(".filter-sidebar").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
    });

    // body background color js
    $(".mm-fullscreen-bg").on('click', function () {
      $(".main-menu-area").removeClass("active");
      $(".filter-sidebar").removeClass("active");
      $(".mm-fullscreen-bg").removeClass("active");
      $("body").removeClass("hidden");
    });

    // product-img full-view & magnific popup
    $('.zoom').on('click', function () {
      $('.product_img_top').magnificPopup({
        delegate: 'a',
        type: 'image',
        showCloseBtn: true,
        closeBtnInside: false,
        midClick: true,
        tLoading: 'Loading image #%curr%...',
        mainClass: 'mfp-img-mobile',
        gallery: {
          enabled: true,
          navigateByImgClick: true,
          preload: [0, 1]
        }
      }).magnificPopup('open');
    });

    /**
     * Form to middleware
     */

    async function sendMiddleware(data) {
      var authToken = localStorage.getItem("authToken");;

      //if(!authToken) {
      await $.ajax({
        type: 'POST',
        url: 'https://shopifyapp.tourtools.eu/mw/login',
        data: { user: 'blueside' },
        headers: {
          'Access-Control-Allow-Origin': '*',
        },
        success: function (data, textStatus, xhr) {
          authToken = data.token;

          localStorage.setItem("authToken", authToken);
        },
        error: function (request, textStatus, errorThrown) {
          console.log('error');
        }
      });
      //}

      await $.ajax({
        type: 'POST',
        url: 'https://shopifyapp.tourtools.eu/mw/forward',
        data: data,
        headers: {
          'Access-Control-Allow-Origin': '*',
          'Authorization': `${authToken}`
        },
        success: async function (data, textStatus, xhr) {
          console.log(data);
        },
        error: async function (request, textStatus, errorThrown) {
          console.log('error');
        }
      });
    }

    $('form#formful__form_form_9UwjJWrL-s').on('submit', async function (el) {
      const now = new Date();
      const formattedDate = now.toLocaleString('it-it').replace(',', '');
      const errors = $(this).find('.formful__error').text() ? true : false;



      const store_name = $('[data-label="Nome store"]:first').val(),
        request = $('[data-label="Richiesta"]:first').val(),
        page_url = $('input[name="page[url]"]:first').val(),
        page_title = $('input[name="page[title]"]:first').val(),
        lang = $('input[name="customerLocale"]:first').val();

      const data = {
        submission_id: 0,
        created: formattedDate,
        customer_ip: '',
        language: lang,
        source_id: 'rivenditori blueside',
        entity_id: 0,
        name_surname: $('#field-firstName').val() + ' ' + $('#field-lastName').val(),
        store_name: store_name,
        company: $('#field-company').val(),
        email: $('#field-email').val(),
        phone: $('#field-phone').val(),
        country: '',
        city: $('#field-city').val(),
        province: '',
        sector: '',
        serial_number: '',
        instrument: '',
        malfunction: '',
        note: request,
        marketing_permission: 0,
        privacy_permission: 1,
        page_title: page_title,
        page_url: page_url
      };

      if (errors) {
        return false
      }
      sendMiddleware(data);

      return false;
    });

    $('form#contact_form').on('submit', async function (el) {
      const now = new Date();
      const formattedDate = now.toLocaleString('it-it').replace(',', '');

      const data = {
        submission_id: 0,
        created: formattedDate,
        customer_ip: '',
        language: $('html').attr('lang'),
        source_id: 'sito blueside',
        entity_id: 0,
        name_surname: el.target[2].value + ' ' + el.target[3].value,
        store_name: '',
        company: '',
        email: el.target[4].value,
        phone: el.target[5].value,
        country: '',
        city: '',
        province: '',
        sector: '',
        serial_number: '',
        instrument: '',
        malfunction: '',
        note: el.target[6].value,
        marketing_permission: 0,
        privacy_permission: 1,
        page_title: el.target[8].value,
        page_url: window.location.href,
        productSku: el.target[9].value,
      };

      sendMiddleware(data);

      return false;
    });

    /** header top */
    function debounce(func, wait) {
      let timeout;
      return function () {
        clearTimeout(timeout);
        timeout = setTimeout(func, wait);
      };
    }

    const updateHeaderPosition = debounce(function () {
      const top = $('.top-notification-bar').height();
      $('#shopify-section-header .header-kaj.with-topbar').css('top', top);
    }, 150); // aspetta 150ms dopo l'ultimo evento resize

    $(document).ready(updateHeaderPosition);
    $(window).on('resize', updateHeaderPosition);
  });
})(jQuery);
